// extracted by mini-css-extract-plugin
module.exports = {"project":"OrgList_project__B0urp","stat":"OrgList_stat__1Ixm9"};